import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import Header from "../../../Components/adminDashboard/Header/Header";
import { useNavigate } from "react-router-dom";
import storeIcon from "../../../assets/images/cat_Icon.png";
import pencilIcon from "../../../assets/images/pencil.svg";
import deleteIcon from "../../../assets/images/bin.svg";
import eyeIcon from "../../../assets/images/eye.svg";
import combinedServices from "../../../shared/services/user-service";

const StoreList = () => {
  const navigate = useNavigate();
  const [stores, setStores] = useState([]);
  const [totalStores, setTotalStores] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteStatus, setDeleteStatus] = useState();

  const totalPages = Math.ceil(totalStores / limit);

  useEffect(() => {
    const fetchStores = async () => {
      try {
        let storeList = await combinedServices.getstore(
          page,
          limit,
          searchQuery
        );
        console.log("asdsad", storeList);
        if (storeList && storeList.data.data.stores) {
          // Parse all JSON string fields
          const parsedStores = storeList.data.data.stores.map((store) => ({
            ...store,
            storeimage: store.storeimage ? JSON.parse(store.storeimage) : [],
            district: store.district ? JSON.parse(store.district) : [],
            storeadmins: store.storeadmins ? JSON.parse(store.storeadmins) : []
          }));

          setStores(parsedStores || []);
          setTotalStores(storeList.data.data.total || 0);
        }
      } catch (error) {
        console.error("Error fetching stores:", error);
      }
    };

    fetchStores();
  }, [page, limit, searchQuery, deleteStatus]);

  const formatDistricts = (districts) => {
    if (!districts || !Array.isArray(districts)) return "";
    return districts.map((d) => `D${d}`).join(", ");
  };

  const formatAdminNames = (admins) => {
    if (!admins || !Array.isArray(admins)) return "";
    return admins
      .map((admin) => `${admin.firstname} ${admin.lastname}`)
      .join(", ");
  };

  const handleButtonClick = () => {
    navigate("/createstore");
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  const deleteStore = async (id) => {
    console.log("Deleting store with ID:", id);
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      });

      if (result.isConfirmed) {
        const response = await combinedServices.deleteStore({
          store_id: id
        });
        if (response.data.status === 200) {
          setDeleteStatus(response.data.message);
          Swal.fire(
            "Deleted!",
            response.data.message || "The store has been deleted.",
            "success"
          );
        } else if (response.data.status === 400) {
          setDeleteStatus(response.data.message);
          Swal.fire(
            "Warning!",
            response.data.message || "This store has connected products",
            "warning"
          );
        } else {
          Swal.fire(
            "Warning!",
            "The store may have been deleted, but an unexpected response was received.",
            "warning"
          );
        }
      }
    } catch (error) {
      console.error("Error deleting store:", error);
      Swal.fire("Error!", "Failed to delete the store.", "error");
    }
  };

  const toggleStoreStatus = async (id) => {
    try {
      const response = await combinedServices.storeStatusChange({
        store_id: id
      });
      console.log("Response from status change:", response);
      if (response.status === 200) {
        setDeleteStatus(response.data.message);
        Swal.fire(
          "Changed!",
          response.data.message || "The store status has been updated.",
          "success"
        );
      } else {
        Swal.fire(
          "Warning!",
          "The store status may have been changed, but an unexpected response was received.",
          "warning"
        );
      }
    } catch (error) {
      console.error("Error changing status:", error);
      Swal.fire("Error!", "Failed to change status of store.", "error");
    }
  };

  return (
    <>
      <Header />
      <div className="dbAdminRight newDbRight">
        <div className="dbMid dbInner">
          <div className="dbMainHd">Store Management</div>
          <div className="catFilterWrp">
            <form>
              <div className="catFilterCont">
                <div className="filWrp">
                  <label className="label2">Showing</label>
                  <select
                    id="selectField"
                    value={limit}
                    onChange={handleLimitChange}
                    className="form_ctrl ctrlDrop"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                  <span className="ent">entries</span>
                  <div className="srchGrp">
                    <input
                      type="text"
                      id="searchField"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      className="form_ctrl ctrlSrch"
                      placeholder="Search Stores"
                    />
                  </div>
                </div>
              </div>
            </form>
            <button className="nambaBtn" onClick={handleButtonClick}>
              + Add New Store
            </button>
          </div>
          <div className="listTablWrp">
            <div className="tblWrp">
              <table>
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Store Name</th>
                    <th>District</th>
                    <th>Admins</th>
                    <th>Created On</th>
                    <th>Updated On</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {stores.length > 0 ? (
                    stores.map((store, index) => (
                      <tr key={store.store_id}>
                        <td>{(page - 1) * limit + index + 1}</td>
                        <td>
                          <div className="catPara">
                            <img
                              src={
                                store.storeimage.length > 0
                                  ? store.storeimage[0]
                                  : storeIcon
                              }
                              alt="storeIcon"
                            />
                            {store.storename}
                          </div>
                        </td>
                        <td>{formatDistricts(store.district)}</td>
                        <td>{formatAdminNames(store.storeadmins)}</td>
                        <td>
                          {new Date(store.createdOn).toLocaleDateString()}
                        </td>
                        <td>
                          {new Date(store.updatedOn).toLocaleDateString()}
                        </td>
                        <td>
                          <div className="tblBtnWrp" style={{ width: '200px' }}>
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={store.isAvailable}
                                onChange={() => toggleStoreStatus(store.id)}
                              />
                              <span className="slider"></span>
                            </label>
                            <button
                              className="Btn"
                              onClick={() => navigate(`/admin-store-view/${store.id}`)}
                              title="View Store"
                            >
                              👁️
                            </button>
                            <button
                              className="Btn"
                              onClick={() =>
                                navigate(`/createstore/${store.id}`)
                              }
                            >
                              <img src={pencilIcon} alt="pencilIcon" />
                            </button>
                            <button
                              className="Btn"
                              onClick={() => deleteStore(store.id)}
                            >
                              <img src={deleteIcon} alt="deleteIcon" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6">No stores available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <div className="tblPagiWrp">
              <ul className="pagination namPagi">
                <li>
                  <button
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 1}
                  >
                    Prev
                  </button>
                </li>
                {Array.from({ length: totalPages }, (_, index) => (
                  <li key={index}>
                    <button
                      className={page === index + 1 ? "active" : ""}
                      onClick={() => handlePageChange(index + 1)}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))}
                <li>
                  <button
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page === totalPages}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StoreList;
